import { Options } from 'vue-class-component';
import TimeSelectorComponent from '../../../TimeSelectorComponent/TimeSelectorComponent.vue';
import SceneActionGeneral from '../SceneActionGeneral';

@Options({
  name: 'ActionWaitingTime',
  components: {
    TimeSelectorComponent,
  },
})
export default class ActionWaitingTime extends SceneActionGeneral {
  get isConfirmEnabled() {
    const w = (this.actionToAdd as any).waitTime;
    if (w !== undefined) return !!w;
    return false;
  }
}
